import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, firstValueFrom } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TableSubAccountsService {

  // @ts-ignore
  private _products$ = new BehaviorSubject<table[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  get products$() { return this._products$.asObservable(); }
  get total$() { return this._total$.asObservable(); }

  constructor(private http: HttpClient) {
  }

  getAccountMulti(page: number, pageSize: number, searchTerm?: string) {
    let params: any = {
      page: String(page),
      pageSize: String(pageSize)
    };

    if (searchTerm) {
      params.searchTerm = searchTerm;
    }

    return this.http.get<{ accounts: any[]; total: number }>(
      `${environment.apiUrl}/accountMulti`,
      { params }
    );
  }

  switchAccount(newAccountId: string) {
    return this.http.put<any>(`${environment.apiUrl}/switchaccount`, {
      newAccountId
    });
  }

  updateActive(id: string, active: boolean) {
    return this.http.put(
      `${environment.apiUrl}/accountupdatepermission`,
      { id, active } 
    );
  }

  getReceiptTemplate(): Observable<string> {
    return this.http.get('/assets/templates/HtmlComprovantePix.html', { responseType: 'text' });
  }

  resendWebhook(ids: string[]): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.apiUrl}/webhook/reprocess`, { transactionIds: ids })
    );
  }

  getBankProvider(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/bankProvider`)
  }

  getAccount(): Promise<any> {
    return firstValueFrom(this.http.get(`${environment.apiUrl}/account`));
  }

  getTransactionDetail(id: string): Promise<any> {
    return firstValueFrom(
      this.http.get(`${environment.apiUrl}/gettransactiondetail`, {
        params: { id }
      })
    );
  }

}
